var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSysUser = function SvgSysUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.75c-1.88 0-3.331 1.431-3.331 3.11 0 1.68 1.452 3.112 3.33 3.112 1.88 0 3.332-1.432 3.332-3.111 0-1.68-1.452-3.111-3.331-3.111ZM7.169 7.86c0-2.584 2.203-4.61 4.83-4.61 2.63 0 4.832 2.026 4.832 4.61 0 2.586-2.203 4.612-4.831 4.612-2.628 0-4.831-2.026-4.831-4.611ZM16.249 16.785a7.324 7.324 0 0 0-4.245-1.315h-.008a7.324 7.324 0 0 0-4.247 1.318c-1.222.86-2.108 2.067-2.533 3.435a.75.75 0 0 1-1.432-.446c.526-1.694 1.618-3.172 3.102-4.216A8.822 8.822 0 0 1 12 13.97a8.824 8.824 0 0 1 5.112 1.587c1.483 1.043 2.575 2.519 3.104 4.21a.75.75 0 0 1-1.432.448c-.426-1.366-1.313-2.571-2.535-3.43Z",
    clipRule: "evenodd"
  })));
};
export default SvgSysUser;